import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { Box, CircularProgress } from '@mui/material';
import BoardColumn from './BoardColumn';
import SpinningCustomLogo from '../../../Common/SpinningCustomLogo'; 


export default function BoardView({ boardData, onDragEnd }) {
  if (!boardData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: 400 }}>
        <SpinningCustomLogo size={56} />
      </Box>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Box display="flex" sx={{ overflowX: 'auto', p: 1, pb: 2, mt: 2 }}>
        {boardData.columnOrder.map(columnId => {
          const column = boardData.columns[columnId];
          const candidates = column.candidateIds.map(candidateId => boardData.candidates[candidateId]);
          
          return <BoardColumn key={column.id} column={column} candidates={candidates} />;
        })}
      </Box>
    </DragDropContext>
  );
}
